import type { ReactNode } from "react";

export interface InlineNoteProps {
  children: ReactNode;
}

/**
 * InlineNote — small muted hint with a lock icon.
 *
 * Used for the "Only @nusearch.com accounts" footnote under the Google
 * sign-in button in view 0. Visual spec from `.login-note` in
 * nucce_extension_preview_v17.html.
 *
 * Tokenized: the 10px footnote text → `text-micro` with `font-normal`
 * overriding the role's default 600 back to v17's unweighted footnote.
 */
export function InlineNote({ children }: InlineNoteProps) {
  return (
    <div className="mt-3.5 flex items-center justify-center gap-1 text-micro font-normal text-text-muted">
      <svg
        viewBox="0 0 24 24"
        className="w-3 h-3"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
        focusable="false"
      >
        <title>Lock</title>
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      <span>{children}</span>
    </div>
  );
}
